import { Send, Loader2, CheckCircle2, ExternalLink, ArrowUpRight } from "lucide-react";
import { TaskChip, DocChip } from "./GarvChips";
import { GarvMarkdown } from "./GarvMarkdown";

export function GarvChatTab({ msgs, sending, input, setInput, send, endRef, onQuickAction }) {
  return (
    <>
      <div className="flex-1 overflow-y-auto p-3 space-y-3" data-testid="garv-messages">
        {msgs.map((m, i) => (
          <div key={i} className={m.role === "user" ? "flex justify-end" : ""}>
            <div className={`max-w-[85%] px-3 py-2 rounded-lg text-sm ${m.role === "user" ? "bg-[#C84B31] text-white" : "bg-[#F5F4F0] text-[#1A1A18]"}`}>
              {m.role === "user"
                ? <div className="whitespace-pre-wrap">{m.reply}</div>
                : <GarvMarkdown text={m.reply} />}
              {m.created_tasks?.length > 0 && <div className="mt-2 space-y-1">{m.created_tasks.map((t) => <TaskChip key={t.id} t={t} />)}</div>}
              {m.listed_tasks?.length > 0 && <div className="mt-2 space-y-1">{m.listed_tasks.slice(0, 8).map((t) => <TaskChip key={t.id} t={t} />)}</div>}
              {m.documents?.length > 0 && <div className="mt-2 space-y-1">{m.documents.slice(0, 6).map((d, di) => <DocChip key={di} d={d} />)}</div>}
              {m.completed_tasks?.length > 0 && <div className="mt-2 text-xs text-[#2F6F4E] flex items-center gap-1"><CheckCircle2 className="w-3 h-3" /> Completed: {m.completed_tasks.join(", ")}</div>}
              {m.navigate?.path && <div className="mt-2 text-xs text-[#C84B31] flex items-center gap-1" data-testid="garv-navigate-chip"><ExternalLink className="w-3 h-3" /> Opening {m.navigate.label}…</div>}
              {m.role !== "user" && m.quick_actions?.length > 0 && (
                <div className="mt-2 flex flex-wrap gap-1.5" data-testid="garv-quick-actions">
                  {m.quick_actions.map((qa, qi) => (
                    <button key={qi} onClick={() => onQuickAction?.(qa)} data-testid={`garv-quick-action-${qi}`}
                      className="inline-flex items-center gap-1 rounded-full bg-white border border-[#C84B31]/40 px-2.5 py-1 text-xs font-medium text-[#C84B31] hover:bg-[#C84B31] hover:text-white transition-colors">
                      {qa.label} <ArrowUpRight className="w-3 h-3" />
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
        {sending && <div className="text-xs text-[#68665E] flex items-center gap-1"><Loader2 className="w-3 h-3 animate-spin" /> GARV is thinking…</div>}
        <div ref={endRef} />
      </div>
      <div className="p-3 border-t border-[#E5E3DB] flex items-end gap-2">
        <textarea rows={1} value={input} onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }}
          placeholder="Ask GARV or assign a reminder…" data-testid="garv-input"
          className="flex-1 resize-none input-field !py-2 text-sm max-h-24" />
        <button onClick={send} disabled={sending || !input.trim()} data-testid="garv-send" className="btn-primary !px-3 !py-2"><Send className="w-4 h-4" /></button>
      </div>
    </>
  );
}
